import React from 'react';

export const BrutalistCard = ({ children, className = '', color = '#fff', onClick }) => {
  return (
    <div 
      onClick={onClick}
      className={`
        border-4 border-black p-0 shadow-[8px_8px_0px_0px_rgba(0,0,0,1)] 
        transition-all duration-300 group relative overflow-hidden
        ${onClick ? 'cursor-pointer hover:-translate-y-1 hover:shadow-[12px_12px_0px_0px_rgba(0,0,0,1)] active:translate-x-1 active:translate-y-1 active:shadow-none' : ''}
        ${className}
      `}
      style={{ backgroundColor: color }}
    >
      {children}
    </div>
  );
};

export const BrutalistBadge = ({ children, className = '', variant = 'white' }) => {
  const textLength = String(children).length;
  const fontSizeClass = textLength > 20 ? 'text-[9px]' : textLength > 15 ? 'text-[10px]' : 'text-xs';

  return (
    <span className={`
      inline-block border-2 border-black px-2.5 py-1 font-black uppercase tracking-tighter 
      shadow-[2px_2px_0px_0px_rgba(0,0,0,1)] whitespace-nowrap overflow-hidden text-ellipsis
      ${variant === 'white' ? 'bg-white text-black' : 'bg-black text-white'}
      ${fontSizeClass}
      ${className}
    `}>
      {children}
    </span>
  );
};

export const BrutalistButton = ({ children, className = '', icon, onClick, active, disabled }) => (
  <button 
    onClick={onClick}
    disabled={disabled}
    className={`
      flex items-center gap-2 border-2 border-black px-4 py-2 font-black uppercase tracking-tight text-sm 
      transition-all duration-100 disabled:opacity-50 disabled:cursor-not-allowed
      ${active 
        ? 'bg-black text-white translate-x-0.5 translate-y-0.5 shadow-[1px_1px_0px_0px_rgba(0,0,0,1)]' 
        : 'bg-white text-black shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] hover:-translate-y-0.5 hover:shadow-[6px_6px_0px_0px_rgba(0,0,0,1)]'
      }
      active:translate-x-1 active:translate-y-1 active:shadow-none
      ${className}
    `}
  >
    {icon}
    {children}
  </button>
);

export const BrutalistInput = ({ className = '', ...props }) => (
  <input 
    className={`
      w-full border-2 border-black bg-white px-4 py-3 text-lg font-black placeholder-gray-400 
      shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] focus:outline-none focus:ring-4 focus:ring-black/5 
      transition-all ${className}
    `}
    {...props}
  />
);